import styled from "styled-components";

export const TrafficColor = styled.div`
  width: ${(props) => props.width || "20px"};
  height: ${(props) => props.width || "20px"};
  background-color: ${(props) => props.traffic};
  border-radius: 100%;
  display: inline-block;
`;
